import React from "react";
import "./About.css";
import { useNavigate } from "react-router-dom";

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="about-section py-5">
      <div className="container">

        {/* Heading */}
        <h2 className="text-center fw-bold mb-3 text-success">
          Misbahi Welfare Mission
        </h2>

        <p className="text-center text-muted mb-5">
          Empowering Communities Through Faith, Education & Compassion
        </p>

        <div className="accordion custom-accordion" id="aboutAccordion">

          {/* Who We Are */}
          <div className="accordion-item shadow-sm mb-3 rounded-3 border-0">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button rounded-3 d-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <i className="bi bi-globe2 me-2"></i>
                Who We Are
              </button>
            </h2>

            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#aboutAccordion"
            >
              <div className="accordion-body">
                <p>
                  <strong>Misbahi Welfare Mission</strong> is an Islamic charity
                  operating for over 12 years, dedicated to helping
                  underprivileged communities.
                </p>

                <p>
                  We believe literacy, Islamic education, and financial
                  stability are essential tools for breaking the cycle of
                  poverty.
                </p>
              </div>
            </div>
          </div>

          {/* Our Mission */}
          <div className="accordion-item shadow-sm mb-3 rounded-3 border-0">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed rounded-3 d-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <i className="bi bi-moon-stars-fill me-2"></i>
                Our Mission
              </button>
            </h2>

            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#aboutAccordion"
            >
              <div className="accordion-body">
                <ul className="list-unstyled">
                  <li>✔ Helping the poor</li>
                  <li>✔ Supporting orphans & widows</li>
                  <li>✔ Sponsoring Hafizes & Aalims</li>
                  <li>✔ Supporting Islamic preachers</li>
                  <li>✔ Constructing mosques</li>
                  <li>✔ Financial support for scholars</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Founder */}
          <div className="accordion-item shadow-sm mb-3 rounded-3 border-0">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed rounded-3 d-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <i className="bi bi-person-fill me-2"></i>
                Founder
              </button>
            </h2>

            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#aboutAccordion"
            >
              <div className="accordion-body">
                <p>
                  <strong>Fakhre Gujarat Hazrat Allama Yunus Misbahi Sahib</strong> is a distinguished Sunni Islamic scholar, educator, and humanitarian who has dedicated his life to the service of Islam and humanity. Renowned for his deep knowledge of Islamic teachings and unwavering commitment to social welfare, he has inspired countless individuals through his lectures, educational initiatives, and charitable efforts. His vision emphasizes the importance of combining faith with compassionate action, ensuring that education, moral values, and humanitarian service remain at the heart of community development.
                </p>
                <p>Through his guidance, <strong>Misbahi Welfare Mission  </strong> has expanded its efforts to provide quality Islamic education, support Hifz and Aalim students, empower women's education, offer religious guidance through Darul Ifta services, assist orphans and widows, construct and renovate mosques, develop clean water projects, and provide relief to underprivileged families. These initiatives reflect a commitment to serving society regardless of social or economic background while preserving Islamic values and promoting unity, dignity, and compassion.
                </p>
                <p>Hazrat Allama Yunus Misbahi Sahib firmly believes that education is the foundation of a strong and righteous society. His dedication to nurturing future scholars, promoting authentic Islamic knowledge, and encouraging charitable service has inspired students, volunteers, donors, and well-wishers across India and abroad. Under his guidance, numerous educational and welfare projects have been established to improve lives, strengthen communities, and create opportunities for future generations.
                </p>
                <p>His lifelong mission continues to encourage people to serve humanity with sincerity, integrity, and selflessness. Through his teachings, leadership, and commitment to social welfare, he remains a source of inspiration for those striving to make a meaningful difference in society while upholding the principles of faith, knowledge, and compassion.
                </p>

              </div>
            </div>
          </div>

          {/* Achievement */}
          <div className="accordion-item shadow-sm mb-3 rounded-3 border-0">
            <h2 className="accordion-header" id="headingFour">
              <button
                className="accordion-button collapsed rounded-3 d-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <i className="bi bi-trophy-fill me-2"></i>
                Achievement
              </button>
            </h2>

            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="headingFour"
              data-bs-parent="#aboutAccordion"
            >
              <div className="accordion-body">
                <ul className="list-unstyled">
                  <li>✔ Misbahi Darul-Ifta</li>
                  <li>✔ Misbahi Darul Musannifeen (Maktabul Hasnain)</li>
                  <li>✔ Jamia Mueeniyyah Azharul Uloom</li>
                  <li>✔ 5 Years Aalim Course</li>
                  <li>✔ Misbahi Darul Hifz</li>
                  <li>✔ Misbahi Taleem-un-Niswan</li>
                  <li>✔ Misbahi Taleem-un-Niswan Tanzim</li>
                  <li>✔ Misbahi IT Department</li>
                  <li>✔ Widows Help</li>
                  <li>✔ Water Boring Projects</li>
                  <li>✔ Egypt Students Pocket Cost</li>
                  <li>✔ Group Marriage</li>
                  <li>✔ Masjid Construction</li>
                  <li>✔ Online Academy</li>
                  <li>✔ Chishtiya Darul Yatama</li>
                </ul>
              </div>
            </div>
          </div>



        </div>

        {/* Donation Section */}
        <div className="donation-box text-center mt-5 p-4 rounded-4 shadow-lg">
          <h4 className="fw-bold text-white mb-3 d-flex justify-content-center align-items-center">
            <i className="bi bi-heart-fill me-2"></i>
            Support Our Mission
          </h4>

          <p className="text-light">
            Whatever you give in the path of Allah, He replaces it with
            something better. Your donation helps change lives.
          </p>

          <button
            className="btn btn-light fw-bold px-4 mt-2"
            onClick={() => navigate("/donation")}
          >
            Donate Now
          </button>
        </div>

      </div>
    </div>
  );
}